export default __webpack_public_path__ + "static/media/laravel.0939426e.svg";